<mat-form-field appearance="fill" class="language-select">
    <mat-label>
      <sc-dictionary-label dictionaryKey="tmc-yard.entity.transport.messaging.communicationLanguage"></sc-dictionary-label>
    </mat-label>
    <mat-select [formControl]="formControl" [required]="required">
        <mat-option *ngFor="let language of availableLanguages" [value]="language.key">
            <sc-dictionary-label dictionaryKey="common.enum.language.{{language.key}}"></sc-dictionary-label>
        </mat-option>
    </mat-select>
</mat-form-field>
